import { CONTAINS, IS_EMPTY, IS_NOT_EMPTY, IS_NOT_TEXT, IS_TEXT, NOT_CONTAINS, STARTS_WITH } from '../filter-conditions.js';
export const textFilterConditions = [
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
    IS_TEXT,
    IS_NOT_TEXT,
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map